export default __webpack_public_path__ + "static/media/marker-sky-red-orange.110c96b1.png";